import * as z from "zod";

export interface NotificationChannelSettings {
  desktop: boolean;
  email: boolean;
  push: boolean;
}

export interface ConversationEventNotificationSettings {
  mentionedInConversation: NotificationChannelSettings;
  assignedToConversation: NotificationChannelSettings;
  newMessageInAssignedConversation: NotificationChannelSettings;
  newMessageInUnassignedConversation: NotificationChannelSettings;
}

export interface PlatformConversationEventNotificationSettings {
  chat: ConversationEventNotificationSettings;
  email: ConversationEventNotificationSettings;
  facebookComments: ConversationEventNotificationSettings;
  facebookChat: ConversationEventNotificationSettings;
  instagramComments: ConversationEventNotificationSettings;
  instagramChat: ConversationEventNotificationSettings;
  attentive: ConversationEventNotificationSettings;
  postscript: ConversationEventNotificationSettings;
  tiktok: ConversationEventNotificationSettings;
}

export type NotificationPlatformKey =
  keyof PlatformConversationEventNotificationSettings;

export interface UserNotificationSettings {
  playSoundOnDesktopNotification: boolean;
  supportNotificationSettings: PlatformConversationEventNotificationSettings;
}

export const UserNotificationSettingsZodSchema = z.any(); //TODO: type this
